import noop from 'lodash/noop';
import Vue from 'vue';
import routes from './routes';
import VueRouter from 'vue-router';
import type { RouteConfig, RawLocation, Location } from 'vue-router/types/router';

Vue.use(VueRouter);

export const isLocation = (to: RawLocation): to is Location => {
  return typeof to !== 'string';
};

const router = new VueRouter({
  mode: 'history',
  routes: routes as RouteConfig[],
});

console.log('Initialized Vue 2 router');

interface UpdateQueryParams {
  set?: Record<string, string>;
  remove?: string[];
}

export const updateQueryParamsWithoutReload = async (
  params: UpdateQueryParams,
  _router: VueRouter
) => {
  const query = { ...router.currentRoute.query, ...params.set };
  if (params.remove) {
    for (const key of params.remove) {
      delete query[key];
    }
  }
  return _router
    .replace({
      path: router.currentRoute.path,
      query,
    })
    .catch(noop);
};

export function getGlobalRouter(): VueRouter {
  return router;
}
